package demos.buttons

import androidx.compose.animation.core.animateIntAsState
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.hoverable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsHoveredAsState
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.IntrinsicSize
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.unit.dp


const val THREE_D_BUTTON = "7863c2c7c62c0d270a9f4d091944efc341575f37616bbdadba307615105d1ee5"

@Composable
fun ThreeDButton() {
    Box(
        Modifier
            .fillMaxSize(),
        contentAlignment = Alignment.Center
    ) {
        ThreeDButtonImpl(

        ) {
            Text("Click here!", color = Color.White, fontWeight = FontWeight.Medium)
        }
    }
}

@Composable
private fun ThreeDButtonImpl(
    buttonColor: Color = Color(0xffd736ff),
    radius: Dp = 16.dp,
    content: @Composable RowScope.() -> Unit,
) {
    val interactionSource = remember { MutableInteractionSource() }
    val isHovered by interactionSource.collectIsHoveredAsState()

    var isClicked by remember { mutableStateOf(false) }

    val offset by animateIntAsState(
        targetValue = when {
            isClicked -> 10
            isHovered -> 25
            else -> 20
        }
    )
    Box(
        Modifier
            .graphicsLayer { rotationX = 15f }
            .pointerHoverIcon(PointerIcon.Hand)
            .hoverable(interactionSource)
            .pointerInput(Unit) {
                detectTapGestures(
                    onPress = {
                        isClicked = true
                        awaitRelease()
                        isClicked = false
                    }
                )
            }
            .width(IntrinsicSize.Max)
            .height(IntrinsicSize.Min)
    ) {

        Box(
            Modifier.fillMaxSize()
                .offset { IntOffset(0, offset) }
                .background(
                    Color.Black.copy(alpha = .3f),
                    shape = RoundedCornerShape(radius)
                )
        )

        Box(
            Modifier.fillMaxSize()
                .background(
                    color = buttonColor,
                    shape = RoundedCornerShape(radius)
                )
                .background(
                    brush = Brush.verticalGradient(
                        colors = listOf(
                            Color.Transparent,
                            Color.Black.copy(alpha = .3f),
                        ),
                    ),
                    shape = RoundedCornerShape(radius)
                )
        )

        Box(
            Modifier.fillMaxSize()
                .offset { IntOffset(0, -offset) }
                .background(
                    color = buttonColor,
                    shape = RoundedCornerShape(radius)
                )
                .background(
                    brush = Brush.verticalGradient(
                        colors = listOf(Color.White.copy(alpha = .3f), Color.Transparent)
                    ),
                    shape = RoundedCornerShape(radius)
                )
                .border(
                    width = (1f).dp,
                    brush = Brush.verticalGradient(
                        colors = listOf(
                            Color.White.copy(alpha = .5f),
                            Color.Transparent,
                            Color.Black.copy(alpha = .1f)
                        )
                    ),
                    shape = RoundedCornerShape(radius)
                )
                .padding(horizontal = 32.dp, vertical = 16.dp)
        ) {
            Row(content = content)
        }
    }
}